export type SalesTargetSegment = 'all' | 'lunch' | 'dinner';

export const COMPANY_MONTHLY_SALES_TARGET = 3_600_000;

export const STORE_MONTHLY_SALES_TARGETS: Record<string, number> = {
  koen: 2_500_000,
  'loop-hamburg': 1_100_000,
};

export const countOperatingDays = (yearMonth: string): number => {
  const [year, month] = yearMonth.split('-').map(Number);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  let count = 0;
  for (let day = 1; day <= lastDay; day += 1) {
    // 月曜日（UTCでも年月日が変わらないようUTCで判定）を定休日として除外する。
    if (new Date(Date.UTC(year, month - 1, day)).getUTCDay() !== 1) count += 1;
  }
  return count;
};

export const segmentMonthlyTarget = (
  storeId: string,
  segment: SalesTargetSegment,
  lunchRatio: number,
): number => {
  const storeTarget = STORE_MONTHLY_SALES_TARGETS[storeId] ?? 0;
  if (segment === 'lunch') return storeTarget * lunchRatio;
  if (segment === 'dinner') return storeTarget * (1 - lunchRatio);
  return storeTarget;
};

export const hourlySalesTarget = ({
  storeId,
  segment,
  date,
  lunchRatio,
  hourCount,
}: {
  storeId: string;
  segment: SalesTargetSegment;
  date: string;
  lunchRatio: number;
  hourCount: number;
}): { monthly: number; daily: number; hourly: number; operatingDays: number } => {
  const monthly = segmentMonthlyTarget(storeId, segment, lunchRatio);
  const operatingDays = countOperatingDays(date.slice(0, 7));
  const daily = operatingDays > 0 ? monthly / operatingDays : 0;
  return {
    monthly,
    daily,
    hourly: hourCount > 0 ? daily / hourCount : 0,
    operatingDays,
  };
};
